// styles/mapControlsStyles.js
export const mapControlsStyles = {
  injectStyles: () => {
    // Check if styles are already injected
    if (document.getElementById('map-controls-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'map-controls-styles';
    style.textContent = `
      /* Map Controls Container */
      .map-controls-container {
        display: flex;
        position: relative;
        margin: 10px;
        z-index: 1;
        gap: 10px;
      }
      
      /* Control Buttons */
      .control-button {
        display: flex;
        align-items: center;
        background-color: white;
        border-radius: 4px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
        padding: 8px 12px;
        cursor: pointer;
        font-family: 'Avenir Next', 'Helvetica Neue', Arial, sans-serif;
        font-size: 14px;
        user-select: none;
        transition: background-color 0.2s;
        border: none;
      }
      
      .control-button:hover {
        background-color: #f8f8f8;
      }
      
      .control-button:focus {
        outline: 2px solid #0079c1;
        outline-offset: 2px;
      }
      
      .control-label {
        margin-left: 8px;
        font-weight: 500;
      }
      
      /* Dropdown Styles */
      .control-dropdown {
        position: absolute;
        bottom: 100%;
        left: 0;
        margin-bottom: 5px;
        background-color: white;
        border-radius: 4px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
        overflow: hidden;
        font-family: 'Avenir Next', 'Helvetica Neue', Arial, sans-serif;
      }
      
      .basemap-dropdown {
        width: 140px;
      }
      
      .legend-dropdown {
        width: 250px;
        max-height: 300px;
        overflow-y: auto;
        padding: 10px;
      }
      
      /* Control Options */
      .control-option {
        display: block;
        width: 100%;
        padding: 10px 15px;
        text-align: left;
        border: none;
        background: none;
        font-family: 'Avenir Next', 'Helvetica Neue', Arial, sans-serif;
        font-size: 14px;
        cursor: pointer;
        transition: background-color 0.2s;
      }
      
      .control-option:hover {
        background-color: #f0f0f0;
      }
      
      .control-option:focus {
        outline: 2px solid #0079c1;
        outline-offset: -2px;
        position: relative;
        z-index: 2;
      }
      
      .control-option.active {
        background-color: #e2f1fb;
        font-weight: 600;
      }
      
      .control-option.active::after {
        content: "✓";
        position: absolute;
        right: 10px;
      }
      
      /* Legend Styles */
      .legend-header {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 10px;
      }
      
      .legend-category {
        margin-bottom: 8px;
      }
      
      .category-title {
        font-weight: 600;
        margin-bottom: 5px;
        font-size: 13px;
      }
      
      .category-header {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
      
      .legend-toggle-icon,
      .legend-item-toggle {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        color: #555;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        transition: background-color 0.2s;
      }
      
      .legend-toggle-icon:hover,
      .legend-item-toggle:hover {
        background-color: #eee;
      }
      
      .legend-toggle-icon:focus,
      .legend-item-toggle:focus {
        outline: 2px solid #0079c1;
        outline-offset: 2px;
      }
      
      .legend-item {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        margin-left: 12px; /* Indent item under category */
      }
      
      .legend-swatch {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        border-radius: 2px;
      }
      
      .legend-label {
        font-size: 12px;
        flex-grow: 1;
      }
      
      .legend-empty {
        color: #666;
        font-style: italic;
        padding: 10px 0;
      }
    `;

    document.head.appendChild(style);
  },

  removeStyles: () => {
    const existingStyle = document.getElementById('map-controls-styles');
    if (existingStyle) {
      existingStyle.remove();
    }
  },
};
